import axios from 'axios';

const API = '/api/operator';
// Isolate the expected 401 from the operator-session probe from the global
// JWT interceptor. A missing operator cookie must never end a valid employee
// or department-admin session during application startup.
const operatorApi = axios.create({ withCredentials: true });

export const hasPersistedOperatorView = (serializedDepartment) => {
  if (!serializedDepartment) return false;
  try {
    return JSON.parse(serializedDepartment)?.role === 'operator';
  } catch {
    return false;
  }
};

export const startOperatorLogin = async () =>
  (await operatorApi.post(`${API}/login/start`)).data;

export const pollOperatorLogin = async (requestId) =>
  (await operatorApi.get(`${API}/login/status/${encodeURIComponent(requestId)}`)).data;

export const getOperatorSession = async () =>
  (await operatorApi.get(`${API}/session`)).data;

export const logoutOperator = async () =>
  (await operatorApi.post(`${API}/logout`)).data;

export const endOperatorSession = async ({ active, clearLocalState }) => {
  if (active) {
    await logoutOperator();
  }
  clearLocalState();
};

export const expireOperatorSession = async ({ clearLocalState }) => {
  clearLocalState();
  try {
    await logoutOperator();
  } catch {
    // The local privilege boundary must close at the absolute deadline even
    // while offline. The server independently enforces the same expiry.
  }
};
